var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{staticClass:"date-select",attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"value-format":"timestamp","size":_vm.size,"clearable":"","prefix-icon":"none","editable":false},on:{"change":_vm.onChange},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }